import axios from 'axios'

const state = {
  minSums: [],
  filials: [],
  isLoading: false,
  isLoadingFilials: false,
  error: null
}

const mutations = {
  SET_MIN_SUMS(state, data) {
    state.minSums = data
  },
  SET_FILIALS(state, data) {
    state.filials = data
  },
  SET_LOADING(state, value) {
    state.isLoading = value
  },
  SET_LOADING_FILIALS(state, value) {
    state.isLoadingFilials = value
  },
  SET_ERROR(state, error) {
    state.error = error
  },
  CLEAR_ERROR(state) {
    state.error = null
  }
}

// Вспомогательная функция для извлечения сообщения об ошибке
function extractErrorMessage(err, defaultMessage) {
  // Пробуем получить ошибку из разных возможных форматов ответа
  if (err.response?.data?.error) {
    return err.response.data.error
  }
  if (err.response?.data?.message) {
    return err.response.data.message
  }
  if (err.response?.data?.title) {
    return err.response.data.title
  }
  if (typeof err.response?.data === 'string') {
    return err.response.data
  }
  return defaultMessage
}

const actions = {
  async fetchAllDistributorMinSums({ commit }) {
    commit('SET_LOADING', true)
    commit('CLEAR_ERROR')
    
    try {
      const response = await axios.get('/Order/GetAllDistributorMinSumsAsync')
      commit('SET_MIN_SUMS', response.data)
    } catch (err) {
      const errorMessage = extractErrorMessage(err, 'Ошибка при загрузке минимальных сумм')
      commit('SET_ERROR', errorMessage)
      
      const Snackbar = {
        text: errorMessage,
        timeout: 7500,
        color: "error",
        linkText: "",
        show: true,
      }
      commit("SET_SNACKBAR", Snackbar, { root: true })
      
      throw err
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchAllFilials({ commit }) {
    commit('SET_LOADING_FILIALS', true)
    
    try {
      const response = await axios.get('/Distributor/GetAll')
      
      const allFilials = []
      
      if (Array.isArray(response.data)) {
        response.data.forEach(distributor => {
          if (distributor.filials && Array.isArray(distributor.filials)) {
            distributor.filials.forEach(filial => {
              allFilials.push({
                id: filial.id,
                name: filial.name
              })
            })
          }
        })
      }
      
      commit('SET_FILIALS', allFilials)
    } catch (err) {
      const errorMessage = extractErrorMessage(err, 'Ошибка при загрузке филиалов')
      commit('SET_ERROR', errorMessage)
      
      const Snackbar = {
        text: errorMessage,
        timeout: 7500,
        color: "error",
        linkText: "",
        show: true,
      }
      commit("SET_SNACKBAR", Snackbar, { root: true })
      
      throw err
    } finally {
      commit('SET_LOADING_FILIALS', false)
    }
  },

  async createDistributorMinSum({ commit }, data) {
    commit('CLEAR_ERROR')
    
    try {
      const response = await axios.post('/Order/CreateDistributorMinSumAsync', data)
      
      const successMessage = 'Минимальная сумма успешно добавлена'
      const Snackbar = {
        text: successMessage,
        timeout: 5000,
        color: "success",
        linkText: "",
        show: true,
      }
      commit("SET_SNACKBAR", Snackbar, { root: true })
      
      return response.data
    } catch (err) {
      const errorMessage = extractErrorMessage(err, 'Ошибка при создании записи')
      commit('SET_ERROR', errorMessage)
      
      const Snackbar = {
        text: errorMessage,
        timeout: 7500,
        color: "error",
        linkText: "",
        show: true,
      }
      commit("SET_SNACKBAR", Snackbar, { root: true })
      
      throw err
    }
  },

  async updateDistributorMinSum({ commit }, data) {
    commit('CLEAR_ERROR')
    
    try {
      const response = await axios.put('/Order/UpdateDistributorMinSumAsync', data)
      
      const successMessage = 'Минимальная сумма успешно обновлена'
      const Snackbar = {
        text: successMessage,
        timeout: 5000,
        color: "success",
        linkText: "",
        show: true,
      }
      commit("SET_SNACKBAR", Snackbar, { root: true })
      
      return response.data
    } catch (err) {
      const errorMessage = extractErrorMessage(err, 'Ошибка при обновлении записи')
      commit('SET_ERROR', errorMessage)
      
      const Snackbar = {
        text: errorMessage,
        timeout: 7500,
        color: "error",
        linkText: "",
        show: true,
      }
      commit("SET_SNACKBAR", Snackbar, { root: true })
      
      throw err
    }
  },

  async deleteDistributorMinSum({ commit }, filialId) {
    commit('CLEAR_ERROR')
    
    try {
      await axios.delete(`/Order/DeleteDistributorMinSumAsync?filialId=${filialId}`)
      
      const successMessage = 'Минимальная сумма успешно удалена'
      const Snackbar = {
        text: successMessage,
        timeout: 5000,
        color: "success",
        linkText: "",
        show: true,
      }
      commit("SET_SNACKBAR", Snackbar, { root: true })
    } catch (err) {
      const errorMessage = extractErrorMessage(err, 'Ошибка при удалении записи')
      commit('SET_ERROR', errorMessage)
      
      const Snackbar = {
        text: errorMessage,
        timeout: 7500,
        color: "error",
        linkText: "",
        show: true,
      }
      commit("SET_SNACKBAR", Snackbar, { root: true })
      
      throw err
    }
  },

  clearError({ commit }) {
    commit('CLEAR_ERROR')
  }
}

const getters = {
  getFilialName: (state) => (filialId) => {
    const filial = state.filials.find(f => f.id === filialId)
    return filial ? filial.name : `Филиал #${filialId}`
  },
  
  getMinSumByFilialId: (state) => (filialId) => {
    const minSum = state.minSums.find(m => m.filialId === filialId)
    return minSum ? minSum.minSum : null
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}